import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3341c25c&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3341c25c')) {
      api.createRecord('3341c25c', component.options)
    } else {
      api.reload('3341c25c', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=3341c25c&", function () {
      api.rerender('3341c25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Button.vue"
export default component.exports